import addDays from 'date-fns/addDays'

import { customFormat, parseCalendarDate } from 'utils/dateUtils'

import { toCalendarIso } from './collectionPeriodBounds'

export const toPausedUntilIso = (value) => {
  const day = toCalendarIso(value)
  if (!day) {
    return null
  }
  return `${day}T12:00:00.000Z`
}

export const getPauseRemindersBounds = ({ deadline, now = new Date() } = {}) => {
  const today = parseCalendarDate(toCalendarIso(now.toISOString()))
  if (!today) {
    return null
  }

  const minDate = customFormat(addDays(today, 1), 'yyyy-MM-dd', false)
  const deadlineDay = parseCalendarDate(toCalendarIso(deadline))
  const maxDate = deadlineDay ? customFormat(addDays(deadlineDay, -1), 'yyyy-MM-dd', false) : null
  const canPause = Boolean(minDate && (!maxDate || minDate <= maxDate))

  return {
    minDate,
    maxDate,
    defaultDate: canPause ? minDate : null,
    canPause,
  }
}

export const pauseRemindersDialogProps = ({ deadline, now } = {}) => {
  const bounds = getPauseRemindersBounds({ deadline, now })
  if (!bounds) {
    return {}
  }

  return {
    minDate: bounds.minDate,
    maxDate: bounds.maxDate || undefined,
    initialDate: bounds.defaultDate || undefined,
  }
}
